import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { redirect } from 'react-router-dom'
import Link from '../Link'
import { Button, Dialog, TextField, Body1, Body2, H4, Toggle } from '../../cdl-react-components/components'
import { getCookie, setCookie } from '../../cdl-react-components/utilities'
import { isValidEmail } from '../../cdl-react-components/utilities/email'
import { post } from '../../cdl-react-components/utilities/requests'
import { AUTH_URL } from '../../cdl-react-components/utilities/constants'
import { setConfiguration } from '../../../store/actions'

class SampleButton extends Component {
    state = {
        open: false,
        loading: false,
        email: '',
        checked: false
    }

    cookieName = 'DigestSampleAuthorized'

    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })

    handleSubmit = async (e) => {
        const { email, loading, checked } = this.state
        if (checked && !loading) {
            this.setState({ errorMessage: undefined, loading: true })
    
            e && e.preventDefault()
    
            if (!isValidEmail(email))
                this.setState({ errorMessage: 'A valid email address is required.', loading: false })
            else {
                const page = window.location.origin + window.location.pathname
                try {
                    /* We don't want to stop execution if these request don't succeed. We 'try' to add them to the mailing list, 
                     * but don't restrict access to samples if there is an issue on our end - rrogers 2020-02-28 */
                    await post(AUTH_URL + '/account/OptinToEmailSubscription', { email, role: 'Mail-9-Articles' }, 'application/json')
                    await post(AUTH_URL + '/email/post', { email, source: 'Digest Samples', page }, 'application/json')
                } 
                catch (error) {
                    console.log(error)
                }
                
                setCookie(this.cookieName, email, 90)
                
                this.props.setConfiguration(true)
                this.setState({ loading: false, open: false })
                this.logSampleDownload(email, page)

                if (this.props.type === 'CDL Map')
                    window.location.href = this.props.href
                else
                    redirect(this.props.href)

            }
        }
    }

    logSampleDownload = (email, page = window.location.origin + window.location.pathname) => {
        post(AUTH_URL + '/email/postSample', { email, page }, 'application/json')
    }

    render() {
        const { type, readSamplePermission } = this.props
        const { open, loading, email, checked, errorMessage } = this.state

        return (
            <Fragment>
                {readSamplePermission ? 
                    (<Link 
                        onClick={() => this.logSampleDownload(email)}
                        className="btn btn--raised" 
                        style={{ width: 'calc(100% - 32px)' }}
                        href={this.props.href}>
                        {this.props.children}
                     </Link>) :
                    (<Button 
                        raised 
                        style={{ width: '100%' }}
                        onClick={this.open}>
                        {this.props.children}
                     </Button>)}
                <Dialog 
                    open={open}
                    onClose={this.close}>
                    <H4>Download a Sample {type}</H4>
                    <Body1>Enter your company email to download a sample {type}</Body1>
                    <form className="sample-email__form" onSubmit={this.handleSubmit}>
                        {errorMessage && <Body1 style={{ color: 'red' }}>{errorMessage}</Body1>}
                        <TextField 
                            label="Company Email" 
                            type="email" 
                            value={email}
                            onChange={(e) => this.setState({ email: e.target.value })}
                            disabled={loading}
                            required />
                        <Body2 style={{ marginTop: '16px', marginBottom: '0' }}>By downloading this content, I agree to Canadian Discovery’s <Link href={window.location.origin + "/terms-use"}>Terms of Use</Link> and <Link href={window.location.origin + "/privacy-policy"}>Privacy Policy</Link>, and consent to receive emails from Canadian Discovery about new products, studies and other free content. I can withdraw my consent at any time.</Body2>
                        <Toggle 
                            type="checkbox" 
                            checked={checked}
                            onChange={(e) => this.setState({ checked: e.target.checked })}
                            required>
                            I Agree
                        </Toggle>
                        <div className="sample-email__form__btn-container">
                            <Button raised disabled={!checked || loading}>{this.props.children}</Button>
                        </div>
                    </form>
                </Dialog>
            </Fragment>
        )
    }

    componentDidMount() {
        const cookie = getCookie(this.cookieName)
        this.props.setConfiguration(!!cookie)
        if (cookie)
            this.setState({ email: cookie })
    }
}

const mapStateToProps = ({ data }) => ({ 
    readSamplePermission: data.configuration.readSamplePermission 
})

const mapDispatchToProps = (dispatch) => ({
    setConfiguration: (readSamplePermission) => dispatch(setConfiguration({ readSamplePermission }))
})

export default connect(mapStateToProps, mapDispatchToProps)(SampleButton)